import Loading from "@/components/Loading";
import AdminLayout from "@/layout/AdminLayout";
import React from "react";
import {PAGE_URL} from "../services/constant";
const AuthzSubjectPermission = React.lazy(() =>
    import('../AuthzSubjectPermission')
);
const authzSubjectPermissionRoutesRegistry = [
    {
        path: PAGE_URL.AUTHZ_SUBJECT_PERMISSION_PAGE,
        element: <AuthzSubjectPermission />,
        loading: <Loading />,
        layout: AdminLayout,
    },
];

export default authzSubjectPermissionRoutesRegistry;
